import React from "react";
import { useStaticQuery, graphql } from "gatsby";



import * as S from './styled';

const Hero = () => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "hero1.jpg"}) {
        childImageSharp {
          fluid(quality: 90, maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }`)
    return (
      
        <S.BackgroundImg
          className="hero"
          fluid={data.file.childImageSharp.fluid}
          alt="Essentia Consultancy"


        />
    );
};

export default Hero;
